// Sold-out developer strength -> in-stock alternative (3Deluxe -> Pro-Oxide).
//
// The shade version of this works on a swatch grid; developers use a <select>,
// so this is a separate, smaller module. What it SHARES with the shade version
// is the part that matters commercially: it drives the existing product form,
// swapping [name=id] to the alternative variant and attaching
// properties[_substitute_for] / [_substitute_for_sku] naming the sold-out
// strength, so the pricing Worker holds the shopper's own price on it.
(function () {
  'use strict';

  var PROP_FOR = 'properties[_substitute_for]';
  var PROP_SKU = 'properties[_substitute_for_sku]';
  var PROP_NAME = 'properties[_substitute_for_name]';

  var cfg = null;
  var pairs = {};          // source variant id -> matched target variant
  var selected = null;     // source variant id currently substituted
  var originalVariantId = null;
  var activeTargetId = null;

  function readCfg() {
    var el = document.getElementById('pdp-developer-swap-data');
    if (!el) return null;
    try { return JSON.parse(el.textContent); } catch (e) { return null; }
  }

  // ── Strength matching ──────────────────────────────────────────────────
  //
  // Deliberately strict. "20V 6%" and "20 Vol (6%)" must pair; "30V 9%" must
  // NEVER pair with "40V 12%". Both the volume AND the percentage have to agree,
  // and anything that does not yield both numbers is refused rather than guessed
  // -- "Tone on Tone" has no strength and must never match anything.
  //
  // Peroxide strength is a chemical property applied to a client's hair. A wrong
  // match here damages hair; a wrong match in the shade version just looks odd.
  function strengthOf(title) {
    var t = String(title || '');
    var vol = t.match(/(\d+)\s*(?:V\b|Vol\b|volume\b)/i);
    var pct = t.match(/(\d+(?:\.\d+)?)\s*%/);
    if (!vol || !pct) return null;
    return { vol: parseInt(vol[1], 10), pct: parseFloat(pct[1]) };
  }

  function sameStrength(a, b) {
    if (!a || !b) return false;
    // Volume and percentage are two expressions of the same thing, so they must
    // corroborate each other. If a listing is mislabelled they will disagree and
    // we decline the match rather than trust one of them.
    return a.vol === b.vol && Math.abs(a.pct - b.pct) < 0.25;
  }

  // Sold-out source variant id -> { source, target }. Only strengths with exactly
  // one in-stock twin are offered; ambiguity is refused outright.
  function pairsFor(cfg) {
    var pairs = {};
    if (!cfg || !cfg.source || !cfg.target) return pairs;

    for (var i = 0; i < cfg.source.length; i++) {
      var src = cfg.source[i];
      if (src.available) continue;               // in stock: nothing to offer
      var srcStrength = strengthOf(src.title);
      if (!srcStrength) continue;                // e.g. "Tone on Tone"

      var match = null;
      var ambiguous = false;
      for (var j = 0; j < cfg.target.length; j++) {
        var tgt = cfg.target[j];
        if (!tgt.available) continue;
        if (!sameStrength(srcStrength, strengthOf(tgt.title))) continue;
        if (match) { ambiguous = true; break; }  // two candidates: refuse both
        match = tgt;
      }
      if (match && !ambiguous) pairs[String(src.id)] = { source: src, target: match };
    }

    return pairs;
  }

  function buildPairs() {
    pairs = pairsFor(cfg);
    window.__pdpDevSub.pairCount = Object.keys(pairs).length;
    window.__pdpDevSub.pairs = pairs;
  }

  // ── Form wiring ────────────────────────────────────────────────────────
  function productForm() {
    var f = document.querySelector('product-form form[action*="/cart/add"]');
    if (f) return f;
    var btn = document.querySelector('product-form button[name="add"]');
    return btn ? btn.form : null;
  }

  function addButton() {
    var f = productForm();
    return f ? f.querySelector('button[name="add"], [type="submit"]') : null;
  }

  function setHidden(form, name, value) {
    var el = form.querySelector('input[name="' + name + '"][data-pdp-dev]');
    if (!el) {
      el = document.createElement('input');
      el.type = 'hidden';
      el.name = name;
      el.setAttribute('data-pdp-dev', '');
      form.appendChild(el);
    }
    el.value = value;
  }

  // The selected strength is sold out, so the theme has put the page into its
  // sold-out state: the submit button reads "Sold out" and Klaviyo's
  // back-in-stock block is shown in its place. The ALTERNATIVE is in stock, so
  // all three have to be corrected or the offer is unusable -- enabling the
  // button alone leaves a shopper looking at a button labelled "Sold out" next
  // to a "Notify me when available" prompt.
  /**
   * The block the theme hides to take the buy button off a sold-out page. It
   * does NOT disable the button -- it puts `hide` (display:none) on this
   * wrapper and shows Klaviyo's block in its place, so correcting the button
   * alone leaves it inside a hidden container and nothing is on screen.
   */
  function buyWrapper(btn) {
    return btn && btn.closest ? btn.closest('.add-to-cart-wrapper') : null;
  }

  function setBuyable(on) {
    var btn = addButton();
    var wrap = buyWrapper(btn);
    if (btn) {
      var txt = btn.querySelector('.txt');
      if (on) {
        // Un-hide the wrapper FIRST. This is the half that was missing, and it
        // is what produced "landing on the page still sometimes makes the
        // button not show": arming the substitute normally makes the theme
        // re-render with an in-stock variant and un-hide this itself, but when
        // our re-arm lands AFTER that render the wrapper stays hidden -- and
        // `pdp-dev-active` has meanwhile hidden Klaviyo's block, so the page
        // ends up with no buy control of any kind. The class is restored in the
        // `off` branch, and only if we were the ones who removed it.
        if (wrap && wrap.classList.contains('hide')) {
          wrap.classList.remove('hide');
          wrap.setAttribute('data-pdp-dev-unhid', '');
        }
        if (btn.disabled) btn.disabled = false;
        btn.removeAttribute('aria-disabled');
        // Idempotent, and deliberately keyed off the CURRENT label rather than
        // off "have we already been here". enforce() calls this again after the
        // theme's re-render has put "Sold out" back, and the old
        // `!hasAttribute('data-pdp-dev-label')` guard made that second call a
        // no-op -- the button stayed reading "Sold out" over a live offer.
        // Re-reading the label each time also keeps the saved value honest if
        // the theme rewrites it.
        if (txt && txt.textContent.trim().toLowerCase() !== 'add to cart') {
          btn.setAttribute('data-pdp-dev-label', txt.textContent);
          txt.textContent = 'Add to cart';
        }
        btn.setAttribute('data-pdp-dev-enabled', '');
      } else if (btn.hasAttribute('data-pdp-dev-enabled')) {
        btn.disabled = true;
        btn.setAttribute('aria-disabled', 'true');
        if (txt && btn.hasAttribute('data-pdp-dev-label')) {
          txt.textContent = btn.getAttribute('data-pdp-dev-label');
        }
        btn.removeAttribute('data-pdp-dev-label');
        btn.removeAttribute('data-pdp-dev-enabled');
        if (wrap && wrap.hasAttribute('data-pdp-dev-unhid')) {
          wrap.classList.add('hide');
          wrap.removeAttribute('data-pdp-dev-unhid');
        }
      }
    }

    // Klaviyo's back-in-stock prompt is about the sold-out strength, which the
    // shopper is being offered a way around. Leaving it visible invites them to
    // wait for stock instead of buying the alternative sitting right there.
    //
    // Done with a CLASS + a CSS !important rule, not by setting the class or the
    // inline style on the element itself. Klaviyo's own script re-shows the
    // wrapper after we hide it -- observed live: our marker attribute survived
    // while the `hide` class had been stripped and display was back to `flex`.
    // Racing it in JS is unwinnable; an !important stylesheet rule beats the
    // inline style it keeps writing, whenever it writes it.
    //
    // GATED ON THERE ACTUALLY BEING SOMETHING TO PRESS. This class suppresses
    // the only other buy control on the page, so switching it on while our own
    // is unusable leaves the shopper with neither. If the button cannot be
    // reached, Klaviyo's block is the better of the two things we have.
    //
    // Deliberately NOT also testing for the `hide` class here. We have just
    // removed it, and if the theme puts it back later the stylesheet rule
    // `.pdp-dev-active .add-to-cart-wrapper.hide` overrides it -- which only
    // works while this class is still on. Testing for it would switch the class
    // off at exactly the moment the rule is needed.
    var usable = !!btn && !btn.disabled && !!wrap;
    document.documentElement.classList.toggle('pdp-dev-active', !!on && usable);
  }

  // The subtree the theme re-renders on a variant change. Falling back to the
  // body is deliberate: observing too much costs a few wasted callbacks, while
  // observing nothing costs the whole feature.
  function observedHost() {
    return document.querySelector('product-form') || document.body;
  }

  function pairByTitle(title) {
    var keys = Object.keys(pairs);
    for (var i = 0; i < keys.length; i++) {
      if (pairs[keys[i]].source.title === title) return pairs[keys[i]];
    }
    return null;
  }

  // The theme re-renders the whole product section on a variant change, and it
  // renders the SOLD-OUT state: "Sold out" button plus Klaviyo's back-in-stock
  // signup. We then correct it. That correction was visible -- the shopper saw
  // a sold-out page flash up and turn into a substitute offer a beat later.
  //
  // Setting this the instant the change fires suppresses the intermediate state
  // via CSS, so the sold-out UI is never painted for a strength we are about to
  // substitute. It is cleared once the real state has been applied.
  function setPending(on) {
    document.documentElement.classList.toggle('pdp-dev-pending', !!on);
  }

  // Which strength is the shopper actually looking at.
  //
  // Deliberately NOT read from the form's [name="id"]. The theme rewrites that
  // asynchronously, and clearSubstitute() restores our saved value into it a
  // moment earlier, so at the instant renderPanel runs it holds the PREVIOUS
  // strength. That produced both halves of a live bug: on the first change the
  // stale id matched no pair, so no offer appeared at all and the shopper was
  // left with Klaviyo's "notify me when it's back"; on the next change it
  // matched the pair the shopper had just left, arming the WRONG strength --
  // and for peroxide the wrong strength is a chemical error, not a cosmetic one.
  //
  // The <select> is the authority: it is what the shopper chose, it is correct
  // synchronously, and it is never rewritten behind us.
  function currentSourcePair() {
    var sel = document.querySelector('.single-option-selector');
    if (sel && sel.value) {
      var byTitle = pairByTitle(sel.value);
      if (byTitle) return byTitle;
      // A strength with no pair is a definite answer, not a miss — do not fall
      // back to the id input and resurrect the previous strength's offer.
      return null;
    }
    var form = productForm();
    var idInput = form ? form.querySelector('[name="id"]') : null;
    return idInput ? (pairs[String(idInput.value)] || null) : null;
  }

  function applySubstitute(pair) {
    var form = productForm();
    if (!form || !pair) return;
    var idInput = form.querySelector('[name="id"]');
    if (!idInput) return;

    if (originalVariantId === null) originalVariantId = idInput.value;
    idInput.value = String(pair.target.id);
    activeTargetId = String(pair.target.id);
    setHidden(form, PROP_FOR, String(pair.source.id));
    setHidden(form, PROP_SKU, pair.source.sku || '');
    // Human label for the basket popup: the product the shopper actually asked
    // for, plus the strength. Falls back to the strength alone rather than to
    // filler text, so a missing title degrades to "20V 6%" not to a sentence
    // fragment reading "the strength you chose 20V 6%".
    var srcName = cfg.sourceTitle ? (cfg.sourceTitle + ' ' + pair.source.title) : pair.source.title;
    setHidden(form, PROP_NAME, srcName);

    setBuyable(true);
    renderDevPackshot(pair);

    selected = String(pair.source.id);
    window.__pdpDevSub.selected = selected;
  }

  function clearSubstitute() {
    var form = productForm();
    if (!form) return;

    // Only restore if OUR value is still in place -- the theme rewrites
    // [name=id] on its own schedule and must not be clobbered.
    if (originalVariantId !== null) {
      var idInput = form.querySelector('[name="id"]');
      if (idInput && activeTargetId && idInput.value === activeTargetId) {
        idInput.value = originalVariantId;
      }
      originalVariantId = null;
      activeTargetId = null;
    }

    // Remove by node, never by blanking: an empty-valued properties[...] still
    // posts the key and still tags the line as a substitute.
    var stale = form.querySelectorAll('input[data-pdp-dev]');
    for (var i = 0; i < stale.length; i++) stale[i].parentNode.removeChild(stale[i]);

    setBuyable(false);
    // Switching 20V -> Tone on Tone has to put the 3Deluxe gallery back, so
    // this is an ordinary revert path, not only a failure path.
    abandonDevView();

    selected = null;
    window.__pdpDevSub.selected = null;
  }

  // ── The product image ──────────────────────────────────────────────────
  //
  // Every strength on this listing is sold out, so without this the shopper
  // spends the whole visit looking at a photograph of a bottle they cannot buy
  // while a different bottle is what actually enters the basket. Each Pro-Oxide
  // strength is photographed separately and prints its strength in large type on
  // the label, so the image is doing real work here -- it is the confirmation
  // that the right strength is going in.
  //
  // DELIBERATELY NOT PAINTED BEFORE FIRST PAINT. The colour substitute hides its
  // gallery from the <head> because it shows a substitute tube for EVERY shade
  // on its product. Here only some strengths pair -- "Tone on Tone" never does
  // -- and the matching lives in JS precisely because Liquid cannot do it
  // safely, so nothing in the head can know whether this page will substitute.
  // Hiding the gallery unconditionally would blank the image on a page we then
  // leave alone, and duplicating the matcher into an inline script would put a
  // peroxide-safety rule in two places. The image therefore swaps when the
  // module arms, which on a strength CHANGE is synchronous in the existing
  // handler; only the first paint of a landing shows the 3Deluxe bottle briefly.

  // The gallery can render more than one group, the inactive ones carrying
  // .hide. Taking the first .pr_lg_img can land on a hidden group, which would
  // insert the bottle where nobody can see it while the real image stays put.
  function galleryHost() {
    return document.querySelector('media-gallery-group:not(.hide) .pr_lg_img')
        || document.querySelector('.pr_lg_img');
  }

  // Mirrored in tests/pdp-developer-substitute.mjs -- keep the two identical.
  function devImageFor(pair, cfg) {
    if (!pair || !pair.target) return null;
    return pair.target.image || (cfg && cfg.targetPackshot) || null;
  }

  // The gallery lives OUTSIDE product-form, so the module's main observer never
  // sees the theme rebuild it. Measured on a strength change: at ~1.9s the theme
  // REPLACES .primgSlider outright and takes the packshot with it. Without this
  // the only thing that put the bottle back was enforce()'s 150ms tick -- and
  // enforce only runs for 6s after a change, so a later rebuild would drop the
  // substituted image permanently, with nothing left to restore it.
  //
  // Its callback deliberately calls ONLY renderDevPackshot, never renderPanel:
  // renderDevPackshot is idempotent (appends only when absent, writes src only
  // when it differs), so its own mutations settle after one pass instead of
  // feeding the observer forever. Rebuilding the panel here would not settle.
  var galleryObserver = null;
  var observedRow = null;

  function observeGallery() {
    var host = galleryHost();
    var row = host && host.parentElement;
    if (!row || row === observedRow) return;
    if (galleryObserver) galleryObserver.disconnect();   // the row itself can be replaced
    observedRow = row;
    var pending = null;
    galleryObserver = new MutationObserver(function () {
      var pair = currentSourcePair();
      if (!pair) return;

      // NO TIMER on the path that matters. When the theme replaces the gallery
      // it takes the packshot with it, and `.pdp-dev-swapped` is still hiding
      // the carousel underneath -- so until the bottle is back the shopper is
      // looking at an empty gallery. Restoring it synchronously, in the same
      // callback as the removal, closes that to nothing.
      //
      // A debounce here would be exactly the wrong tool: setTimeout is clamped
      // to ~1s in a backgrounded tab, so a 20ms debounce silently becomes a
      // second of blank gallery for anyone who switches tabs mid-visit. That is
      // not hypothetical -- it is what this was measured doing.
      //
      // Safe to run unconditionally because renderDevPackshot is idempotent:
      // its own mutations produce one more callback that finds nothing to do.
      if (!document.getElementById('pdp-dev-packshot')) { renderDevPackshot(pair); return; }

      // Everything else (attribute churn, Flickity's own bookkeeping) is only
      // worth a cheap re-assert, so it stays debounced.
      clearTimeout(pending);
      pending = setTimeout(function () {
        var p = currentSourcePair();
        if (p) renderDevPackshot(p);
      }, 20);
    });
    galleryObserver.observe(row, { childList: true, subtree: true });
  }

  // Put the original gallery back. Every revert AND every failure path goes
  // through here, and it tears down ALL of it -- the colour module learned the
  // hard way that restoring the slider while leaving the absolutely-positioned
  // packshot in place shows the substitute image on top of a working gallery,
  // and leaves the thumbnail strip hidden by the surviving class.
  function abandonDevView() {
    // First: the class is what hides the real carousel, so dropping it before
    // anything else means no path can leave a gallery hidden with nothing over it.
    document.documentElement.classList.remove('pdp-dev-swapped');
    var shot = document.getElementById('pdp-dev-packshot');
    if (shot && shot.parentNode) shot.parentNode.removeChild(shot);
    var host = document.querySelector('.pr_lg_img.pdp-dev-host');
    if (host) host.classList.remove('pdp-dev-host');
  }

  // Idempotent by design: enforce() calls this again every 150ms while the theme
  // re-renders, and it must not rewrite src each time -- re-setting src restarts
  // the fetch and flashes the bottle away and back.
  function renderDevPackshot(pair) {
    var src = devImageFor(pair, cfg);
    var host = galleryHost();
    // No image, or nowhere to put it, is a real answer and not a reason to
    // improvise: leave the page's own gallery exactly as the theme rendered it.
    if (!src || !host) { abandonDevView(); return; }

    host.classList.add('pdp-dev-host');
    observeGallery();

    // NOTE: nothing here touches the thumbnail strip. It is hidden for the whole
    // page from the <head>, in pdp-developer-substitute.liquid -- not per
    // strength and not from JS, so it is never painted and nothing moves when
    // the shopper switches. Two earlier attempts to do it from here are why:
    // per-strength hiding made the main image jump ~90px sideways as the strip
    // came and went, and doing it after first paint made the strip flash in.

    var shot = document.getElementById('pdp-dev-packshot');
    if (!shot) {
      shot = document.createElement('div');
      shot.id = 'pdp-dev-packshot';
      shot.className = 'pdp-dev-shot';
      shot.innerHTML = '<img class="pdp-dev-shot__bottle" alt="">';
      host.appendChild(shot);
    }

    var img = shot.querySelector('.pdp-dev-shot__bottle');
    if (img.getAttribute('src') !== src) img.src = src;
    img.alt = (cfg.brand || 'Alternative') + ' ' + pair.target.title;

    // LAST, and only once there is a bottle on screen to cover the carousel.
    // This class is what hides the real slider, via a stylesheet rule rather
    // than an inline style -- see the CSS. Setting it in lockstep with the
    // packshot is what guarantees the two can never disagree: no ordering of
    // re-renders can leave the gallery hidden with nothing over it.
    //
    // Deliberately NOT `pdp-dev-active`, which is toggled on whether the buy
    // button is currently reachable. That flickers off for a tick during the
    // very re-render this guards against, which would un-hide the sold-out
    // bottle at precisely the wrong moment.
    document.documentElement.classList.add('pdp-dev-swapped');
  }

  // ── The offer panel ────────────────────────────────────────────────────
  function removePanel() {
    var p = document.getElementById('pdp-dev-offer');
    if (p && p.parentNode) p.parentNode.removeChild(p);
  }

  function renderPanel() {
    removePanel();

    var pair = currentSourcePair();
    if (!pair) { clearSubstitute(); return; }

    var form = productForm();
    var btn = addButton();
    if (!form || !btn) return;

    var box = document.createElement('div');
    box.id = 'pdp-dev-offer';
    box.className = 'pdp-dev-offer';
    box.setAttribute('role', 'status');

    // No confirm step. The substitute is armed the moment a sold-out strength
    // is selected, so Add to Cart just works and this panel says plainly what
    // will be added. An extra checkbox was one more thing to notice and press
    // between a shopper and a purchase they had already decided on -- but the
    // swap must never be a surprise, so it is stated BEFORE the click as well
    // as confirmed in the basket panel after it.
    box.innerHTML =
      '<p class="pdp-dev-offer__head">'
      + '<span class="pdp-dev-offer__tick" aria-hidden="true">&#10003;</span> '
      + 'Out of stock &mdash; the same strength goes in instead</p>'
      + '<p class="pdp-dev-offer__body"><strong></strong> is in stock and goes in your basket '
      + 'in place of <span class="pdp-dev-offer__src"></span>, at the same price.</p>';

    box.querySelector('strong').textContent = (cfg.brand || 'Alternative') + ' ' + pair.target.title;
    box.querySelector('.pdp-dev-offer__src').textContent = pair.source.title;

    var anchor = btn.parentNode === form ? btn : (btn.parentNode || btn);
    anchor.parentNode.insertBefore(box, anchor);

    // Arm it now rather than waiting for a click.
    applySubstitute(pair);
  }

  var applying = false;
  var pendingBailout = null;

  // ── Holding the correction against the theme's late re-render ──────────
  //
  // Measured live on www, selecting a substitutable strength: at +0ms through
  // +700ms the page was correct (Pro-Oxide armed, button "Add to cart",
  // enabled), and at +1200ms the theme's own async re-render put the SOLD-OUT
  // 3Deluxe variant back into [name="id"] and "Sold out" back on the button --
  // leaving the offer panel sitting above a dead button, with the wrong variant
  // armed. Worse than showing no offer at all.
  //
  // The MutationObserver below cannot catch that: an <input>'s .value is a
  // PROPERTY, not an attribute, so overwriting it produces no MutationRecord at
  // all, and the observer is registered for childList only. So the correction
  // has to be re-asserted rather than fired once.
  //
  // enforce() is idempotent and only writes when the DOM has actually drifted,
  // and it runs on a bounded window after a change rather than forever, so it
  // cannot become a permanent timer fighting the theme.
  var enforceTimer = null;
  var enforceUntil = 0;

  function enforce() {
    var pair = currentSourcePair();
    var form = productForm();
    if (!form) return;
    var idInput = form.querySelector('[name="id"]');
    if (!idInput) return;

    if (!pair) {
      // A strength with nothing to offer. Only act if WE left something armed:
      // the theme owns this state otherwise.
      if (selected !== null) { removePanel(); clearSubstitute(); }
      return;
    }

    var drifted = idInput.value !== String(pair.target.id)
      || !form.querySelector('input[data-pdp-dev]')
      || !document.getElementById('pdp-dev-offer');

    // renderPanel re-arms from scratch; setBuyable alone covers the cheaper case
    // where only the button was reset.
    //
    // The packshot is re-asserted on BOTH branches rather than folded into the
    // drift test. The gallery is outside the observed subtree, so a re-render
    // there produces no callback and nothing else would notice the bottle had
    // gone; and putting it in `drifted` would rebuild the whole offer panel
    // every 150ms whenever the gallery had not rendered yet, which flickers the
    // panel. renderDevPackshot only writes when the DOM has actually changed.
    if (drifted) renderPanel();
    else setBuyable(true);
    renderDevPackshot(pair);

    // Lift the anti-flash suppression the moment the page is genuinely correct,
    // rather than leaving it to the bailout timer. `.pdp-dev-pending` hides the
    // add-to-cart button with visibility:hidden, so every millisecond it stays
    // up past the correction is a shopper looking at a product with no way to
    // buy it -- reported live as "the atc just disappears".
    var btn = addButton();
    var txtEl = btn && btn.querySelector('.txt');
    if (selected && btn && !btn.disabled
        && txtEl && txtEl.textContent.trim().toLowerCase() === 'add to cart') {
      setPending(false);
    }
  }

  function startEnforcing(ms) {
    enforceUntil = Date.now() + (ms || 6000);
    if (enforceTimer) return;
    enforceTimer = setInterval(function () {
      enforce();
      if (Date.now() > enforceUntil) {
        clearInterval(enforceTimer);
        enforceTimer = null;
      }
    }, 150);
  }

  function onVariantChange() {
    // Re-entrancy guard. onVariantChange MUTATES the DOM (inserts the panel,
    // rewrites the button label, adds hidden inputs), and the observer below
    // watches that same subtree -- so without this each run schedules the next
    // one and it never settles. A plain boolean is enough only because the flag
    // is cleared synchronously at the end of this function, before the observer
    // callback (a microtask) can run.
    if (applying) return;
    applying = true;

    // Any real variant change means a different strength: drop any active
    // substitute before deciding what to offer for the new one.
    clearSubstitute();
    renderPanel();
    // renderPanel has either armed the substitute (and corrected the button and
    // the back-in-stock block) or established there is nothing to offer. Either
    // way the page is now in its settled state, so the suppression can lift.
    // Lift the suppression ONLY once the page is genuinely correct. Clearing it
    // at the end of every run was the bug: this function runs synchronously on
    // the change event, i.e. BEFORE the theme's async re-render, so the class
    // was already gone by the time the sold-out markup appeared and the flash
    // showed through. The observer calls back here after the re-render, and
    // that pass is the one allowed to clear it.
    var btn = addButton();
    // Compare case-insensitively: the theme writes 'Add to Cart' (capital C) and
    // the Liquid renders a locale string, so an exact match against our own
    // 'Add to cart' would never be true -- pending would never lift and the buy
    // controls would stay hidden until the 3s bailout.
    var txtEl = btn && btn.querySelector('.txt');
    var label = txtEl ? txtEl.textContent.trim().toLowerCase() : '';
    var settled = !!selected && label === 'add to cart';
    if (settled) setPending(false);

    applying = false;
  }

  function init() {
    window.__pdpDevSub = { pairCount: 0, pairs: {}, selected: null };
    cfg = readCfg();
    if (!cfg) return;
    buildPairs();
    if (!window.__pdpDevSub.pairCount) return;

    renderPanel();
    // A ?variant= link can land straight on a sold-out strength, and the theme
    // still re-renders under us on first paint.
    startEnforcing(6000);

    document.addEventListener('change', function (e) {
      if (!e.target || !e.target.matches) return;
      if (!e.target.matches('.single-option-selector, select, .swatchInput')) return;

      // Decide from the option title, synchronously, before the theme re-renders.
      var willSubstitute = !!pairByTitle(e.target.value);
      setPending(willSubstitute);
      // Safety valve: never leave the buy controls suppressed. If the re-render
      // never arrives, or the substitute cannot be armed for any reason, the
      // page must fall back to whatever the theme rendered rather than sitting
      // there with nothing to press.
      if (willSubstitute) {
        clearTimeout(pendingBailout);
        // 1.5s, not 3s. This is a worst case, not a schedule: enforce() lifts
        // the suppression as soon as the page is correct (measured at ~0ms),
        // so the only thing this timer governs is how long a shopper can be
        // left with no add-to-cart button if the swap never arms at all.
        pendingBailout = setTimeout(function () { setPending(false); }, 1500);
      }
      onVariantChange();
      // The theme's re-render lands about a second from now and undoes all of
      // it. Hold the correction across that window.
      startEnforcing(6000);
    });

    // The theme replaces the section asynchronously and on its own schedule, so
    // a fixed timeout is a race we lose intermittently. Reacting to the DOM
    // actually changing closes the window instead of guessing its width.
    var reapply = null;
    observer = new MutationObserver(function () {
      clearTimeout(reapply);
      reapply = setTimeout(onVariantChange, 20);
    });
    observer.observe(observedHost(), { childList: true, subtree: true });

    document.addEventListener('product:updated', function () {
      cfg = readCfg();
      buildPairs();
      setTimeout(onVariantChange, 60);
      startEnforcing(6000);
    });
  }

  window.__pdpDevSub = { pairCount: 0, pairs: {}, selected: null };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
